import {useAuthUserStore} from "@/stores/auth";

// La API espera a Moodle como mucho ~15 s (5 s de conexión + 10 s de respuesta).
const MOODLE_LINK_TIMEOUT_MS = 16000;

export default {
    index(academyUuid, groupUuid) {
        return useAuthUserStore().getApiClient.get('/v2/projects', {
            params: {
                academy_uuid: academyUuid,
                group_uuid: groupUuid
            }
        })
    },
    // Enlace de acceso al curso en Moodle. La API responde { data: { link } } o un error
    // con { message }. Rechaza si tarda demasiado o si el enlace no es una URL válida.
    getMoodleCourseURL(projectUUID)
    {
        return useAuthUserStore().getApiClient
            .get('/project/' + projectUUID + '/lms/auth', { timeout: MOODLE_LINK_TIMEOUT_MS })
            .then(({ data }) => {
                const link = data?.data?.link

                if (typeof link !== 'string' || !/^https?:\/\//.test(link)) {
                    throw new Error('invalid_moodle_link')
                }

                return link
            })
    },
    get(projectUuid) {
        return useAuthUserStore().getApiClient.post('/project/' + projectUuid)
    },
    put(project) {
        return useAuthUserStore().getApiClient.put('/project', project)
    },
    delete(project) {
        return useAuthUserStore().getApiClient.put('project', project)
    },

    //=============================================================
    //                          SECTIONS
    //=============================================================
    //Actualizará el nombre de la sección.
    putSection(section) {
        return useAuthUserStore().getApiClient.put('/project/sections', section)
    },

    //=============================================================
    //                          LESSONS
    //=============================================================
    //Obtener la lección
    getLesson(lessonUuid, projectUuid)
    {
        return useAuthUserStore().getApiClient.get('/projects/' + projectUuid + '/lessons/' + lessonUuid)
    },

    //=============================================================
    //                          Access
    //=============================================================
    getEnrolConfiguration (project_uuid)
    {
        return useAuthUserStore().getApiClient.get('/v2/projects/' + project_uuid + '/enrol-configuration')
    },
    postEnrolConfiguration(project_uuid, enrolConfiguration)
    {
        return useAuthUserStore().getApiClient.put('/v2/projects/' + project_uuid + '/enrol-configuration', {
            time_start_value: enrolConfiguration.time_start_value,
            time_start_unit: enrolConfiguration.time_start_unit,
            time_end_value: enrolConfiguration.time_end_value,
            time_end_unit: enrolConfiguration.time_end_unit,
        })
    },
    deleteEnrolConfiguration(project_uuid)
    {
        return useAuthUserStore().getApiClient.delete('/v2/projects/' + project_uuid + '/enrol-configuration')
    }

}